export interface IRoadMapBox {
  id: number;
  title: string;
  description: string;
}

export const roadMapData: IRoadMapBox[] = [
  {
    id: 1,
    title: 'تسلط به کتاب درسی',
    description: ' با دیدن ویدیوهای آموزش کتاب درسی، درس به درس جلو می‌ری و به همۀ مفاهیم کتاب‌های درسی‌ت مسلط می‌شی.',
  },
  {
    id: 2,
    title: ' حل نمونه سوال امتحانی',
    description:
      ' بخشی از ویدیوهای آموزش کتاب درسی، به حل نمونه‌ سوال‌های امتحانی اختصاص داره تا برای موفقیت توی امتحان‌های مدرسه و امتحان‌های نهایی آماده بشی.',
  },
  {
    id: 3,
    title: 'موفقیت در آزمون تیزهوشان',
    description:
      ' با خرید اشتراک تیزهوشان، یه دنیا نکته و تست تیزهوشانی رو بررسی می‌کنی و برای ورود به مدارس سمپاد آماده می‌شی. (ویژۀ پایۀ ششم و پایۀ نهم)',
  },
  {
    id: 4,
    title: 'آمادگی برای کنکور',
    description:
      ' با خرید اشتراک کنکور، به کلی ویدیوی آموزش نکته و تست ویژۀ کنکوری‌ها دسترسی داری و با آنالیز۱۰هزار تست کنکوری، برای قبولی توی آزمون کنکور آماده می‌شی.',
  },
  {
    id: 5,
    title: 'جمع‌بندی کنکور',
    description:
      ' برای جمع‌بندی کنکور و رسیدن به رشته و دانشگاه دلخواهت، فقط کافیه ویدیوهای اشتراکی ویژۀ کنکوری‌هارو ببینی و همۀ درس‌ها رو با تست‌های جمع‌بندی، جمع و جور کنی.',
  },
];
